define("media/utils/number-helpers/index", ["exports", "media/utils/number-helpers/compute-sign", "media/utils/number-helpers/floor-to-significant-digits", "media/utils/number-helpers/format-number-with-suffix", "media/utils/number-helpers/is-in-range", "media/utils/number-helpers/precise-round", "media/utils/number-helpers/ratio-to-percent"], function (_exports, _computeSign, _floorToSignificantDigits, _formatNumberWithSuffix, _isInRange, _preciseRound, _ratioToPercent) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "computeSign", {
    enumerable: true,
    get: function () {
      return _computeSign.default;
    }
  });
  Object.defineProperty(_exports, "floorToSignificantDigits", {
    enumerable: true,
    get: function () {
      return _floorToSignificantDigits.default;
    }
  });
  Object.defineProperty(_exports, "formatNumberWithSuffix", {
    enumerable: true,
    get: function () {
      return _formatNumberWithSuffix.default;
    }
  });
  Object.defineProperty(_exports, "isInRange", {
    enumerable: true,
    get: function () {
      return _isInRange.default;
    }
  });
  Object.defineProperty(_exports, "preciseRound", {
    enumerable: true,
    get: function () {
      return _preciseRound.default;
    }
  });
  Object.defineProperty(_exports, "ratioToPercent", {
    enumerable: true,
    get: function () {
      return _ratioToPercent.default;
    }
  });
  0; //eaimeta@70e063a35619d71f0,"media/utils/number-helpers/compute-sign",0,"media/utils/number-helpers/floor-to-significant-digits",0,"media/utils/number-helpers/format-number-with-suffix",0,"media/utils/number-helpers/is-in-range",0,"media/utils/number-helpers/precise-round",0,"media/utils/number-helpers/ratio-to-percent"eaimeta@70e063a35619d71f
});